import React from "react";
import styles from './Preloader.module.sass'
import cn from 'classnames';

const Preloader = ({ visibility = false }) => {

    return  <div className={cn(styles.preloader, visibility ? '' : styles.hide)}>
                    <img src="assets/Logo.svg"/> 
                </div>
};

export default Preloader;